import Cookies from "js-cookie";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { AddFundData, deleteFundData, getFundById, updateFundData } from "../../api/api";
import { AddParticipants, FetchSecurityMaster } from "../../api/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { GridReadyEvent } from "ag-grid-community";
import _ from "lodash";
import { Button } from "../../components/Button/Button";
import { useGetFundList } from "../../data/data";
import { Container, Offcanvas, Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const AddFund = () => {
  const emptyParamData = {
      fundID: 0,
      fund: "",
      fundName: "",
      openDate: null,
      fundType: "",
      fundMinorIndustryType: "",
      priceSchedule: "",
      baseCurrency: "",
      clientFundCode: null,
      fundRefCode: null,
      fundOpenDate: null
  };

  const [showmsg, setShowmsg] = useState(false);
  const [showmsgError, setShowErrormsg] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [fundData, setFundData] = useState<any>([]);
  const [selectedFundData, setSelectedFundData] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [showModel, setShowModel] = useState(false);
  const [selectedFundID, setSelectedFundID] = useState<any>(null);
  const [selectedEditFundID, setSelectedEditFundID] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  const [showForm, setShowForm] = useState(false);
  const { data, isFetching, refetch } = useGetFundList(
    "Fund",
    parseInt(selectedClient),
    Cookies.get("newJwt")
  );
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);


  function handleAddFund(e: any) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const payload = Object.fromEntries(formData.entries());
    if(!selectedEditFundID){
      AddFundData(payload, Cookies.get("newJwt"))
      .then((response) => response.text())
      .then((response) => {
        const responseObject = JSON.parse(response);

        // Check if the object has an "errors" property
        //responseObject.errors[0].message
        if ("errors" in responseObject) {
          toast.error("Error: " + responseObject.errors[0].message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success("Fund Created Successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          refetch();
        }
      });
    }
    if(selectedEditFundID){
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => value !== "")
      );
      updateFundData(selectedEditFundID, filteredPayload, Cookies.get("newJwt"))
      .then((response) => response.text())
      .then((response) => {
        if (response === '') {
          toast.success("Fund Updated Successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          refetch();
        }else{
          toast.error("Error in Fund Update", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
    }

  }
  
  const handleFundType = (item: any) => {
    const isChecked = selectedRows.includes(item);
    if (isChecked) {
      setSelectedRows(selectedRows.filter((row: any) => row !== item)); // remove item from selected rows
    } else {
      setSelectedRows([...selectedRows, item]); // add item to selected rows
    }
  };
  
  useEffect(() => {
    setFundData(data);
  }, [data]);

  const showAddFund = () => {
    setShowForm(true);
    setSelectedFundData([emptyParamData])
  };
  const handleCancel = () => {
    setShowForm(false)
    setSelectedFundData([emptyParamData])
    setSelectedEditFundID(null);
  }

  function editData( data:any ) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setShowForm(true);
    setSelectedEditFundID(data?.data?.fundID)
    //setGetEditMetadataID(id);
    getFundById(data?.data?.fundID, Cookies.get("newJwt"))
      .then((response) => response?.json())
      .then((response) => {
        setSelectedFundData(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function handleCloseClick() {
    setShowmsg(false);
    setSelectedFundData(null)
  }
  function deleteData(data: any) {
    setSelectedFundID(data.data);
    setShowModel(true);
  }

  const handleClose = () => {
    setShowModel(false);
  };

  const handleDelete = () => {
    const id = selectedFundID.fundID;
    deleteFundData(id, Cookies.get("newJwt"))
      .then((response) => {
        // Handle the response if needed
        setShowModel(false);
        toast.success("Deleted successfully!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        refetch();
      })
      .catch((error) => {
        // Handle the error if needed
        console.log(error);
        toast.error("Error Deleting Metadata!", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

 

  const columns = [
    {
      headerName: "Fund",
      field: "fund",
      //flex: 1,
      floatingFilter: true,
      filter: "agTextColumnFilter",
      width: 300,
    },
    {
      headerName: "Fund Name",
      field: "fundName",
      //flex: 1,
      floatingFilter: true,
      filter: "agTextColumnFilter",
      width: 300,
    },
    {
      headerName: "Fund Type",
      field: "fundType",
      floatingFilter: true,
      filter: "agSetColumnFilter",
      width: 300,
    },
    {
      headerName: "Actions",
      field: "",
      flex: 1,
      //width: 190,
      //cellClass: "text-center",
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span
              onClick={() => editData({ data: params.data })}
              className="cursor-pointer"
            >
              <i title="edit" className="fas fa-fw fa-edit"></i>
            </span>
            <span
              onClick={() => deleteData({ data: params.data })}
              className="cursor-pointer ml-4"
            >
              <i title="delete" className="fas fa-fw fa-trash"></i>
            </span>
          </>
        );
      },
    },
  ];

  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        if (params.column.colId.includes("Locked")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (params.column.colId.includes("Status")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }
       
        if (typeof params.value === "undefined" ) {
          // Format numbers as currency with the currency symbol
          return `--`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
  
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;
  
    doc.setFontSize(8);
  
    const title = "Fund List";
    const headers = [
      [
        "Fund",
        "Fund Name",
        "Fund Type",
      ],
    ];
  
    const transactionData = fundData.map((e: any) => [
      e.fund !== null ? `${e.fund}` : "--",
      e.fundName !== null ? `${e.fundName}` : "--",
      e.fundType !== null ? `${e.fundType}` : "--",
    ]);
  
    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };
  
    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Fund.pdf");
  };
  
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Fund</h1>
      </div>
      <div className="row w-100 card py-4 px-2">
        <div className="tradeForm position-relative">
          <div>
            {showmsg ? (
              <div
                className="alert alert-danger alert-dismissible mb-0 mt-4 statusAlert"
                role="alert"
              >
                <div className="alert-message">
                  {showmsgError ? showmsgError : successMessage}
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={handleCloseClick}
                ></button>
              </div>
            ) : null}
            <div className="col-sm-12 d-inline-block">
              <Button
                type="submit"
                className="btn-primary float-end mx-2"
                size="btn-xs"
                children={"Add Fund"}
                //showLoading={isBtnLoading}
                onClick={showAddFund}
              />
            </div>
            {showForm ? (
              <form className="w-75 my-2" onSubmit={handleAddFund}>
                <div className="row">
                  <label className="mb-3 col-md-2">Fund</label>
                  <div className="mb-3 col-md-4">
                    {/* <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      name="fund"
                      defaultValue={selectedFundData?.fund}
                    ></input> */}
                    <select className="form-control" name="fund" value={selectedFundData?.fund}>
                      <option value="">Select Fund</option>
                      {data?.map((e: any) => {
                        return <option value={e.fund} key={e.fund}>{e.fund}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="row">
                  <label className="mb-3 col-md-2">Fund Name</label>
                  <div className="mb-3 col-md-4">
                    {/* <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      name="fundName"
                      defaultValue={selectedFundData?.fundName || ""}
                    ></input> */}
                    <select className="form-control" name="fundName" value={selectedFundData?.fundName}>
                      <option value="">Select Fund Name</option>
                      {data?.map((e: any) => {
                        return <option value={e.fundName} key={e.fund}>{e.fundName}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="row">
                  <label className="mb-3 col-md-2">Amount</label>
                  <div className="mb-3 col-md-4">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Amount"
                      name="transactionAmount"
                      disabled={selectedFundData?.fundName ? true : false}
                    ></input>
                  </div>
                </div>
                <div className="row">
                  <label className="mb-3 col-md-2">Account Type</label>
                  <div className="mb-3 col-md-4">
                    <select
                      className="form-control"
                      name="fundType"
                      value={selectedFundData?.fundType || ""}
                    >
                      <option value="">Select</option>
                      <option value="Cash">Cash</option>
                      <option value="Pool">Pool</option>
                      <option value="Trust">Trust</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <label className="mb-3 col-md-2">Price Schedule</label>
                  <div className="mb-3 col-md-4">
                    <select
                      className="form-control"
                      name="priceSchedule"
                      value={selectedFundData?.priceSchedule || ""}
                    >
                      <option value="">Select</option>
                      <option value="Daily">Daily</option>
                      <option value="Monthly">Monthly</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <label className="mb-3 col-md-2">Open Date</label>
                  <div className="mb-3 col-md-4">
                    <input
                      type="date"
                      className="form-control"
                      placeholder=""
                      name="openDate"
                      defaultValue={
                        selectedFundData?.fundOpenDate
                          ? new Date(selectedFundData?.fundOpenDate)
                              ?.toISOString()
                              .split("T")[0]
                          : ""
                      }
                    ></input>
                  </div>
                </div>
                <div className="mb-3 col-md-12 mt-4">
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="btn btn-outline-primary me-2"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            ) : null}

            <div
              className="ag-theme-alpine"
              style={{
                height: "500px",
                width: "100%",
              }}

            >
                <div className="my-2 col-sm-12 text-end px-3">
                  <i
                    className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                    style={{ fontSize: "16px" }}
                    onClick={handleExportExcel}
                  ></i>
                  <i
                    className="align-middle far fa-fw fa-file-pdf cursor-pointer"
                    onClick={() => handleExportPdf()}
                    style={{ fontSize: "16px" }}
                  ></i>
                </div>
              {isFetching ? (
                <div className="w-100 grid_loader">
                  <div className="spinner-border text-dark me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <AgGridReact
                ref={dataGridRefMain}
                  rowData={fundData}
                  columnDefs={columns}
                  animateRows={true}
                  domLayout={"normal"}
                  pagination={true}
                  paginationPageSize={20}
                  className="px-2"
                  rowSelection={"multiple"}
                ></AgGridReact>
              )}
            </div>
          </div>
        </div>
        <Modal
          show={showModel}
          onHide={handleClose}
          centered
          className="modelComponent"
        >
          <Modal.Header closeButton>
            <Modal.Title>Fund data</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you Sure, You want to Delete Fund data</Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Close"
              onClick={handleClose}
            />

            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Delete"
              onClick={handleDelete}
            />
          </Modal.Footer>
        </Modal>
      </div>
      <ToastContainer />
    </div>
  );
};

export { AddFund };
